import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { About, Events, Home } from "./pages";

export const WebRoutes = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route index path="/" element={<Home />} />
          <Route index path="/about" element={<About />} />
          <Route index path="/events" element={<Events />} />
        </Routes>
      </Router>
    </>
  );
};
